// import { StrictMode } from "react";
// gatsbyjs.com/docs/reference/built-in-components/gatsby-script/
import React from 'react';
import RootElement from './src/components/RootElement';
require('./src/styles/global.scss');

const { TRACKING_LIBS, IS_CHINA_SITE } = require('./src/utils/analytics/constants');
const { isBot, appendScript } = require('./src/utils/analytics/index');

export const wrapRootElement = ({ element }) => {
  return <RootElement>{element}</RootElement>;
};

export const onClientEntry = () => {
  if (isBot() || IS_CHINA_SITE) return;
  
  // Hubspot SPA - Step 1: Set up the path for the initial page view
  // https://developers.hubspot.com/docs/reference/api/analytics-and-events/tracking-code#tracking-in-single-page-applications
  let _hsq = window._hsq = window._hsq || [];
  _hsq.push(['setPath', window?.location.pathname || '']);
  
  appendScript(TRACKING_LIBS.GoogleTagManager);
};

export const onInitialClientRender = () => {
  if (isBot() || IS_CHINA_SITE) return;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (isBot() || IS_CHINA_SITE) return;
  if (!prevLocation) return;
  
  // Hubspot SPA - Step 2: Tracking subsequent page views
  // timeout is needed to wait for document.title
  setTimeout(() => {
    let _hsq = window._hsq = window._hsq || [];
    _hsq.push(['setPath', location?.pathname || window?.location.pathname]);
    _hsq.push(['trackPageView']);
  }, 500);
};